import Button from "hardcover-ui/components/Button";
import faPlus from "icons/solid/plus.svg";
import Icon from "hardcover-ui/components/Icon";
import useCurrentUser from "hooks/fragments/useCurrentUser";

export default function NewListButton() {
  const username = useCurrentUser((user) => user?.username);
  if(!username) {
    return false;
  }

  return (
    <div>
      <Button
        variant="primary"
        size="lg"
        as={{
          element: "link",
          props: {
            href: `/@${username}/lists/new`,
          },
        }}
      >
        <Icon icon={faPlus} size="md" />
        <span>Create a List</span>
      </Button>
    </div>
  );
}
